import {Component, OnDestroy, OnInit} from '@angular/core';
import {
  ActivityModel,
  BusinessModel, EActivityOfferStatus,
  EProjectStatus, EProjectType, MaterialModel, OfferContentModel,
  ProjectModel,
  UserModel,
} from '../../@models';

import {Subscription} from 'rxjs';
import {ApiService} from '../../@core/service/api.service';
import {NbToastrService} from '@nebular/theme';
import {applyFilter} from '../../@core/common/filter';
import {SidebarCommon} from '../../@core/common/sidebar';
import { AuthGuardService } from '../../@core/service/auth-guard.service';

@Component({
  selector: 'ngx-my-offers',
  templateUrl: './my-offers.component.html',
  styleUrls: ['./my-offers.component.scss'],
})
export class MyOffersComponent extends SidebarCommon<ActivityModel> implements OnInit, OnDestroy {

  offers: ActivityModel[];

  selected: ActivityModel;

  subscription: Subscription;

  public search: string;

  me: UserModel;

  ////////////////////////////////////////////////////////////////////////////

  p: number = 1;

  ////////////////////////////////////////////////////////////////////////////
  business: BusinessModel[];
  businessSubscription: Subscription;


  ProjectType = EProjectType;
  ProjectStatus = EProjectStatus;
  OfferType = EActivityOfferStatus;

  projectStatusMap: { id: number; name: string }[] = [];

  ////////////////////////////////////////////////////////////////////////////

  edit: string;
  offerStatusMap: { id: number; name: string }[] = [];


  customer: BusinessModel;

  ////////////////////////////////////////////////////////////////////////////

  constructor(private api: ApiService, private auth: AuthGuardService, private toastrService: NbToastrService) {
    super();
    // this.api.loadMe().subscribe(x => this.me = x);
  }

  ngOnInit(): void {

    this.auth.loadMe().then(x => this.me = x);

    for (const n in EActivityOfferStatus) {
      if (typeof EActivityOfferStatus[n] === 'number') {
        this.offerStatusMap.push({id: <any>EActivityOfferStatus[n], name: n});
      }
    }

    for (const n in EProjectStatus) {
      if (typeof EProjectStatus[n] === 'number') {
        this.projectStatusMap.push({id: <any>EProjectStatus[n], name: n});
      }
    }

    this.subscription = this.api.myOfferList().subscribe(of => {
      this.offers = of;
    });

    this.businessSubscription = this.api.reloadBusiness().subscribe(b => this.business = b);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.businessSubscription.unsubscribe();
  }


  create() {
    super.create();
  }

  cancel(item: ActivityModel) {
    this.hideSidebar();
  }

  save(item: ActivityModel) {
    // todo add verification

    /* if (this.customer == null) {
      this.toastrService.danger('Customer is required', 'Error');
    } else if (item.businessUnit == null) {
      this.toastrService.danger('BU is required', 'Error');
    } else if (item.name == null || item.name.length === 0) {
      this.toastrService.danger('Name is required', 'Error');
    } else if (item.type == null) {
      this.toastrService.danger('Type is required', 'Error');
    } else if (item.status == null) {
      this.toastrService.danger('Status is required', 'Error');
    } else {
      if (item.material === 'null') item.material = null;
      this.hideSidebar();
      if (item._id == null) {
        const newProjectCustomer = JSON.parse(JSON.stringify(this.customer));
        newProjectCustomer.projects.push(item);
        this.api.saveBusiness(newProjectCustomer).subscribe(async (i) => {
          this.toastrService.success(`Project '${i.name}' saved!`, 'Success');

          this.projects = await this.api.myProjectList().toPromise()
        });
      } else {
        this.api.saveProject(item)
          .subscribe(async (i) => {
            this.toastrService.success(`Project '${i.name}' saved!`, 'Success');
            this.projects = await this.api.myProjectList().toPromise()
          });
      }
    }*/
  }

  isDeactivated(item: ActivityModel) {
    return  ['Cancelled', 'OnHold', 'Finished']
      .includes((item.project as ProjectModel || {status: ''}).status as undefined as string);
  }


  filter(search: string, projects: ActivityModel[]): ActivityModel[] {
    // return applyFilter<ActivityModel>(search, projects,
    // ['pobusinessUnit', 'customer', 'project', 'equipment', 'offerTitle', 'status', 'text']);
    if (search == null || search.length === 0) return projects;

    const s = search.toLowerCase(); // search.toLowerCase().split(/\s/);
    // console.log(s);
    return projects.filter(x =>
      (x.project as ProjectModel)?.active &&
      (((x.project || {}) as ProjectModel).businessUnit.name || '').toLowerCase().includes(s) ||
      ((x.business as BusinessModel).name || '').toLowerCase().includes(s) ||
      (((x.project || {}) as ProjectModel).name || '').toLowerCase().includes(s) ||
      (((((x.project || {}) as ProjectModel).material as undefined as MaterialModel || {name: ''}).name || '')
        .toLowerCase().includes(s) ||
      (x.title || '').toLowerCase().includes(s) ||
      ((x.content as OfferContentModel).text || '').toLowerCase().includes(s))
    )
      
  }

  async saveOffer(item: any) {
    await this.api.updateOffer(item);
    this.edit = null;
  }

  reload() {
    this.edit = null;
    if (this.subscription) this.subscription.unsubscribe();
    if (this.businessSubscription) this.businessSubscription.unsubscribe();
    for (const n in EProjectStatus) {
      if (typeof EProjectStatus[n] === 'number') {
        this.projectStatusMap.push({id: <any>EProjectStatus[n], name: n});
      }
    }

    this.subscription = this.api.myOfferList().subscribe(of => {
      this.offers = of;
    });

    this.businessSubscription = this.api.reloadBusiness().subscribe(b => this.business = b);
  }
}
